import {  ErrorObservable  } from './ErrorObservable';

export const _throw = ErrorObservable.create;


// WEBPACK FOOTER //
// ./~/rxjs/src/observable/throw.ts